import React from "react";
import { useGameState } from "context/GameContext";
import { Abilities, RoundState } from "context/interfaces/GameContextInterface";
import Flash from "react-reveal/Flash";
// Css
import classes from "./Tip.module.scss";

const Policy: React.FC = () => {
  const { roundState, activeAbility } = useGameState();

  return (
    <div className={classes.container}>
      <h2 className={classes.title}>Tip board</h2>
      <Flash>
        {(roundState === RoundState.PickingChancellor ||
          roundState === RoundState.votingGovernment ||
          roundState === RoundState.PresidentRule ||
          roundState === RoundState.ChancellorRule) && (
          <p className={classes.desc}>
            The first president is chosen randomly and marked by a little emblem
            below his/her card, now he/she should choose one of the players of
            his/her choice as chancellor, initiate a vote and if the majority of
            players voted “ja”, choose the accept button, otherwise tap the
            decline button to deliver the government to the next president.
          </p>
        )}
      </Flash>
      <Flash>
        {roundState === RoundState.AbilityActive &&
          activeAbility === Abilities.Search && (
            <p className={classes.desc}>
              Now the president can pick a player and sees his/her role,
              remember that the president can reveal the result of this phase as
              a lie!
            </p>
          )}
      </Flash>
      <Flash>
        {roundState === RoundState.AbilityActive &&
          activeAbility === Abilities.Kill && (
            <p className={classes.desc}>
              Now the president can pick a player and kill his/her, if the
              killed guy was hitler; liberals wins!
            </p>
          )}
      </Flash>
      <Flash>
        {roundState === RoundState.AbilityActive &&
          activeAbility === Abilities.NextPresident && (
            <p className={classes.desc}>
              Now the president can pick a player and make his/her the next true
              president just for once!
            </p>
          )}
      </Flash>
      <Flash>
        {roundState === RoundState.GameFinished && (
          <p className={classes.desc}>Game just finished!</p>
        )}
      </Flash>
    </div>
  );
};

export default Policy;
